import * as R from 'ramda';

angular.module('tct.mappingService', [])
  .factory('mappingService', mappingService);

function mappingService() {
  const factory = {
    objectKeysToCamel,
    objectKeysToSnake,
    toCamelCase,
    toSnakeCase,
  };

  return factory;

  function objectKeysToCamel(object) {
    if (Array.isArray(object)) {
      return R.map(o => objectKeysToCamel(o), object);
    } else if (object instanceof Object) {
      return R.curry((fn, obj) => R.fromPairs(R.map(
        pair => [fn(pair[0]), objectKeysToCamel(pair[1])], R.toPairs(obj))))(toCamelCase, object);
    }

    return object;
  }

  function objectKeysToSnake(object) {
    if (Array.isArray(object)) {
      return R.map(o => objectKeysToSnake(o), object);
    } else if (object instanceof Object) {
      return R.curry((fn, obj) => R.fromPairs(
        R.map(
          pair => [fn(pair[0]), objectKeysToSnake(pair[1])], R.toPairs(obj))))(toSnakeCase, object);
    }

    return object;
  }

  function toCamelCase(key) {
    return key.replace(/(_[a-z])/g, $1 => $1.toUpperCase().replace('_', ''));
  }

  function toSnakeCase(key) {
    return key.replace(/([A-Z])/g, $1 => `_${$1.toLowerCase()}`);
  }
}
